import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';
import { useCallback, useState } from 'react';

interface IMenuItem {
  title: string;
  handleClick?: (isOpen: boolean) => void;
  defaultOpen?: boolean;
  children?: any;
}

const useStyles = makeStyles(() => ({
  summary: {
    padding: 0,
    display: 'block',
    backgroundColor: '#E8E8E8'
  },
  accordion: {
    marginBottom: 16,
    '&.Mui-expanded': {
      margin: 0,
      marginBottom: 16,
    },
    '&::before': {
      display: 'none',
    },
    width: '100%',
    backgroundColor: '#F6F6F6',
    padding: '10px 10px 10px 10px',
  },
  accordionSummary: {
    backgroundColor: '#E8E8E8',
    fontWeight: 700,
    minHeight: 48,
    '&.Mui-expanded': {
      minHeight: 48,
    },
    '& .MuiAccordionSummary-content': {
      margin: '12px 0',
    },
  },
  paper: {
    width: '100%',
    backgroundColor: '#F6F6F6',
    padding: '10px 50px 10px 50px',
    margin: '10px 10px 20px'
  }
}));

export const ExpandableLoanRatesTable = ({
  children,
  defaultOpen = false,
  handleClick,
  title,
}: IMenuItem) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(defaultOpen);

  const onClick = useCallback(() => {
    setOpen(!isOpen);
    if (handleClick) handleClick(!isOpen);
  }, [isOpen]);

  return (
    <Accordion defaultExpanded={isOpen} elevation={0} onClick={onClick}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls={`${title}-content`}
        id={title}
        className={classes.accordionSummary}
      >
        <p>{title}</p>
      </AccordionSummary>
      <AccordionDetails className={classes.accordion}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};